module.exports = "data:image/gif;base64,R0lGODlhDQAHAJH/AP///w1pgwAAAMDAwCH5BAEAAAMALAAAAAANAAcAQAIOhI9pwazbwpsqymdnPgUAOw=="